import { useNavigate } from "react-router-dom";
import { BinBadge } from "./Bin/BinBadge";
import ProfileMenu from "./ProfileMenu";
import { usePermission } from "../../hooks/usePermission";
import {
  DeleteAttendeesPermission,
  CreateEventsPermission,
  DeleteEventsPermission,
} from "../../constants/permissions";

export default function ProfileNav() {
  const navigate = useNavigate();

  const { data: canCreateEvents } = usePermission({
    permissionName: CreateEventsPermission,
  });

  const { data: canDeleteAttendees } = usePermission({
    permissionName: DeleteAttendeesPermission,
  });

  const { data: canDeleteEvents } = usePermission({
    permissionName: DeleteEventsPermission,
  });

  return (
    <>
      <div className="container flex flex-column justify-end  mt-4">
        <div className="flex justify-end gap-2 container-fluid container-md items-center flex-wrap">
          <button
            data-track="event-registration-button"
            data-module="Register"
            onClick={() => window.open("/register", "_blank")}
            className="rounded-md bg-yellowColor px-3 py-2 flex items-center gap-2 mr-3"
          >
            <i className="fa-solid fa-address-card text-white"></i>
            <span className="text-white">Event Registration</span>
          </button>

          {canCreateEvents && (
            <button
              data-track="add-event-button"
              data-module="Events"
              onClick={() => navigate("/add-event")}
              className="rounded-md bg-purpleColor px-3 py-2 flex items-center gap-2 AddEventBtn"
            >
              <i className="fa fa-plus text-white"></i>
              <span className="text-white">Add Event</span>
            </button>
          )}
          {(canDeleteAttendees || canDeleteEvents) && <BinBadge />}
          <ProfileMenu />
        </div>
      </div>
    </>
  );
}

// <AlertBadge />
// const [show2FAPrompt, setShow2FAPrompt] = useState(false);

// useEffect(() => {
//   const check2FAStatus = async () => {
//     try {
//       const currentUser = auth.currentUser;
//       if (!currentUser) {
//         return;
//       }

//       const is2FAEnabled = await twoFactorService.is2FAEnabled(currentUser.uid);

//       if (is2FAEnabled === false || is2FAEnabled === undefined) {
//         setShow2FAPrompt(true);
//       }
//     } catch (error) {
//       console.error("Error checking 2FA status:", error);
//     }
//   };

//   check2FAStatus();
// }, []);

//   <TwoFactorDialog
//   isOpen={show2FAPrompt}
//   onClose={() => setShow2FAPrompt(false)}
// />
